import { render } from "./SwitchView.vue?vue&type=template&id=5cc0265f&scoped=true"
import script from "./SwitchView.vue?vue&type=script&lang=js"
export * from "./SwitchView.vue?vue&type=script&lang=js"

import "./SwitchView.vue?vue&type=style&index=0&id=5cc0265f&scoped=true&lang=css"

import exportComponent from "C:\\Work\\huabiao-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cc0265f"]])

export default __exports__